import { Button } from '@/components/_ui/Button'
import {
  NavigationMenu,
  NavigationMenuContent,
  NavigationMenuList,
  NavigationMenuItem,
  NavigationMenuTrigger,
} from '@/components/_ui/NavigationMenu'
import useParseLinkUrlWithLocale from '@/lib/hooks/routing/useParseLinkUrlWithLocale'
import useGlobalStore from '@/store/useGlobalStore'
import Image from 'next/image'

import { useState } from 'react'
import { useNavigationDisableOverlappingEvents } from '@/lib/hooks/helpers/useNavigationDisableOverlappingEvents'
import AccountPopover from '../_shared/AccountDrawer'
import LoginPopover from '../_shared/LoginPopover'
import { DesktopCountrySelector } from '../DesktopHeader/DesktopCountrySelector'
import { MobileCountrySelector } from '../MobileHeader/MobileDrawer/MobileCountrySelector'
import { CartBadge } from '../_shared/CartBadge'

export const AccountPageHeader = () => {
  const {
    user: { isSignedIn },
    app: { alpha2 },
    setApp,
  } = useGlobalStore()
  const { parseLinkUrlWithLocale } = useParseLinkUrlWithLocale()
  const { disableEvent, targetRef } = useNavigationDisableOverlappingEvents()
  const [isCountrySelectorOpen, setIsCountrySelectorOpen] = useState(false)

  return (
    <NavigationMenu>
      <div
        style={{ zIndex: 1000 }}
        className="m-auto flex h-[60px] w-screen items-center justify-center bg-white"
      >
        <div className="flex w-full max-w-[1400px] items-center justify-between px-3 sm:px-5">
          <a
            href={parseLinkUrlWithLocale({ url: '/' })}
            className="outline-offset-4"
          >
            <Image src="/unicity.svg" alt="Unicity" width={120} height={100} />
          </a>
          <NavigationMenuList>
            <div className="flex items-center justify-end xl:space-x-2">
              <NavigationMenuItem className="pointer-events-auto hidden list-none md:block">
                <NavigationMenuTrigger
                  className="rounded-full px-1"
                  ref={(ref) => {
                    // eslint-disable-next-line react-compiler/react-compiler
                    targetRef.current[0] = ref
                  }}
                  onClick={(event) => {
                    if (disableEvent) {
                      event.preventDefault()
                    }
                  }}
                >
                  <Image
                    className="mx-2"
                    src={`/flags/${alpha2}.svg`}
                    alt="Country Selector"
                    height={25}
                    width={25}
                  />
                </NavigationMenuTrigger>

                <NavigationMenuContent>
                  <DesktopCountrySelector />
                </NavigationMenuContent>
              </NavigationMenuItem>
              <button
                type="button"
                className="mx-2 block cursor-pointer px-1 md:hidden"
                onClick={() => setIsCountrySelectorOpen(true)}
              >
                <Image
                  src={`/flags/${alpha2}.svg`}
                  alt="Country Selector"
                  height={25}
                  width={25}
                />
              </button>

              {isSignedIn ? <AccountPopover size={30} /> : <LoginPopover />}

              <Button
                className="pointer-events-auto"
                onClick={() => {
                  setApp({ isCartOpen: true })
                }}
                size="icon"
                variant="icon"
              >
                <Image
                  src="/icons/empty-cart.svg"
                  alt="Cart"
                  height={25}
                  width={25}
                />
                <CartBadge />
              </Button>
            </div>
          </NavigationMenuList>
        </div>
      </div>
      <MobileCountrySelector
        isCountrySelectorOpen={isCountrySelectorOpen}
        setIsCountrySelectorOpen={setIsCountrySelectorOpen}
      />
    </NavigationMenu>
  )
}
